import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CFormSelect,
  CRow,
  CSmartTable,
  CTable,
  CTableBody,
  CTableHead,
} from '@coreui/react-pro'
import moment from 'moment'
import PlayerService from 'src/service/PlayerService'
const FixturePlayerStatsTab = (props) => {
  const [statsData, setStatsData] = useState([])
  const handlePlayer = (e) => {
    const playerId = e.target.value
    PlayerService.playerStatsByFixture(playerId).then((res) => {
      if (res.success) {
        setStatsData(res.data)
      }
    })
  }
  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CFormSelect
              aria-label="Select player"
              name="player"
              className={'form-control'}
              onChange={handlePlayer}
              id="player"
            >
              <option value={0}>Select Player</option>
              {props.playerList &&
                props.playerList.map((item, key) => (
                  <option value={item?.id} key={key}>
                    {item?.full_name}
                  </option>
                ))}
            </CFormSelect>
            <CTable className="main-table table innertable">
              <CTableHead color="dark">
                <tr>
                  <th>Date</th>
                  <th>Team</th>
                  <th>FP</th>
                  <th>SC</th>
                  <th>HW</th>
                  <th>AW</th>
                  <th>AL</th>
                  <th>HL</th>
                  <th>SSW</th>
                  <th>SSL</th>
                  <th>OWT</th>
                  <th>BWM</th>
                  <th>BLM</th>
                </tr>
              </CTableHead>
              <CTableBody>
                {statsData &&
                  statsData.map((item, key) => (
                    <tr key={key}>
                      <td> {moment(item.fixture.start_date).format('D.MM.YYYY')}</td>
                      <td>{item?.teamName}</td>
                      <td>{item.fantasy_points}</td>
                      <td>{item?.sc}</td>
                      <td>{item?.hw}</td>
                      <td>{item?.aw}</td>
                      <td>{item?.al}</td>
                      <td>{item?.hl}</td>
                      <td>{item?.ssw}</td>
                      <td>{item?.ssls}</td>
                      <td>{item?.owt}</td>
                      <td>{item?.bwm}</td>
                      <td>{item?.blm}</td>
                    </tr>
                  ))}
                {statsData.length === 0 && (
                  <tr>
                    <td colSpan={15}>No record yet available.</td>
                  </tr>
                )}
              </CTableBody>
            </CTable>
          </CRow>
        </CCardBody>
      </CCard>
    </>
  )
}

export default FixturePlayerStatsTab
